import Notification from '@rio-cloud/rio-uikit/Notification';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import { authNotificationConsumed, selectAuthNotification } from './authSlice';

const AuthNotificationListener = () => {
    const dispatch = useAppDispatch();
    const notification = useAppSelector(selectAuthNotification);

    useEffect(() => {
        if (notification === null) {
            return;
        }

        dispatch(authNotificationConsumed());
        Notification[notification.type](notification.message);
    }, [dispatch, notification]);

    return null;
};

export default AuthNotificationListener;
